import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import  axios from 'axios';
import store from './store/index'
import moment from 'moment'
// router setup
import router from './routes/index';
import VueAnalytics from "vue-analytics";
import Echo from "laravel-echo";
// plugin setup
Vue.use(DashboardPlugin);
// let token = document.head.querySelector('meta[name="csrf-token"]');
// if (token) {
//     axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// }else {
//     console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
// }
moment.locale('es');

const isProd = process.env.NODE_ENV === 'production'

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALITICS,
  autoTracking: {
    exception: true
  },
  router,
  debug: {
    enable: !isProd,
    sendHitTask: isProd
  }
})

window.Pusher = require("pusher-js");
window.Echo = new Echo({
  broadcaster: 'pusher',
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  wsHost: process.env.VUE_APP_PUSHER_HOST,
  wsPort: process.env.VUE_APP_PUSHER_PORT,
  wssPort: process.env.VUE_APP_PUSHER_PORT,
  forceTLS: false,
  encrypted: true,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
  auth: {
    headers: {
      Authorization: "Bearer " + window.localStorage.token_backoffice,
    },
  },
  authEndpoint: process.env.VUE_APP_BROADCAST_API,
});

Vue.config.productionTip = false
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.localStorage.token
axios.defaults.baseURL = window.location.origin+'/api/v1';

if (process.env.VUE_APP_ENV === 'production') {
    axios.defaults.baseURL = window.location.origin+'/api/v1';
}else{
    axios.defaults.baseURL = process.env.VUE_APP_API_CATERING;
}
/* eslint-disable no-new */
new Vue({
  el: '#app',

  render: h => h(App),
  router,
   store,
});
